import { migration as initial } from "./001_initial";
import { migration as repairPayrollNumbering } from "./002_repair_payroll_numbering";
import { migration as repairPayrollAndSlipNumbering } from "./003_repair_payroll_and_slip_numbering";

export const migrations = [initial, repairPayrollNumbering, repairPayrollAndSlipNumbering];
